import React from 'react';
import { ApolloClient, InMemoryCache, HttpLink, ApolloProvider } from '@apollo/client';
import ReactOnRails from 'react-on-rails';
import SprintsListContainer from '../containers/SprintsListContainer';
import SprintCreateModal from '../components/Sprints/SprintCreateModal';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';

const client = new ApolloClient({
  link: new HttpLink({
    uri: '/graphql',
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': ReactOnRails.authenticityToken() },
  }),
  cache: new InMemoryCache(),
});

class SprintsListPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isModalOpen: false, editingSprint: null };
  }

  componentDidMount() {
    this._createHandler = () => this.setState({ isModalOpen: true, editingSprint: null });
    this._editHandler = (e) => this.setState({ isModalOpen: true, editingSprint: e.detail });
    window.addEventListener('open-sprint-create', this._createHandler);
    window.addEventListener('open-sprint-edit', this._editHandler);
  }

  componentWillUnmount() {
    if (this._createHandler) window.removeEventListener('open-sprint-create', this._createHandler);
    if (this._editHandler) window.removeEventListener('open-sprint-edit', this._editHandler);
  }

  render() {
    const { isModalOpen, editingSprint } = this.state;
    return (
      <ApolloProvider client={client}>
        <SuccessionThemeProvider company={this.props?.company} user={this.props?.current_user}>
          <SprintsListContainer {...this.props} />
          <SprintCreateModal
            isOpen={isModalOpen}
            onClose={() => this.setState({ isModalOpen: false, editingSprint: null })}
            ownerName={this.props?.current_user?.allowed_name || this.props?.current_user?.name}
            sprint={editingSprint}
            onCreated={(sprint) => {
              this.setState({ isModalOpen: false, editingSprint: null });
              window.location.href = `/succession/sprint?sprintId=${sprint.id}`;
            }}
            onUpdated={() => {
              this.setState({ isModalOpen: false, editingSprint: null });
              window.location.reload();
            }}
          />
        </SuccessionThemeProvider>
      </ApolloProvider>
    );
  }
}

export default SprintsListPage;

